import React, { FC } from "react";

import Button from "../../elements/Button";
import CheckBox from "../../elements/CheckBox";
import SelectWithCheckboxes from "../../elements/SelectWithCheckboxes";
import classes from "./HubSpotSelector.module.scss";
import { SelectOptionType } from "../../elements/Select/Select";

type HubSpotSelectorProps = {
  label: string;
  value: string[] | number[];
  options: SelectOptionType[];
  buttonLabel: string;
  onButtonClick: () => void;
  onChange: (e: any) => void;
  disabled?: boolean;

  isChecked?: boolean;
  checkboxLabel?: string;
  onCheckboxChange?: (event: React.ChangeEvent<{}>, checked: boolean) => void;
};

const HubSpotSelector: FC<HubSpotSelectorProps> = ({
  label,
  value,
  options,
  onButtonClick,
  onChange,
  buttonLabel,
  disabled,
  isChecked,
  checkboxLabel,
  onCheckboxChange,
}) => {
  return (
    <div className={classes.selectorContainer}>
      <div className={classes.selector}>
        <SelectWithCheckboxes
          className={classes.selector}
          label={label}
          options={options}
          value={value}
          onChange={onChange}
        />
      </div>
      <div className={classes.selectorControls}>
        <Button onClick={onButtonClick} disabled={disabled}>
          {buttonLabel}
        </Button>

        {onCheckboxChange && checkboxLabel && (
          <CheckBox label={checkboxLabel} value={isChecked} onChange={onCheckboxChange} />
        )}
      </div>
    </div>
  );
};

export default HubSpotSelector;
